import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, SmartphoneIcon, ZapIcon, CheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const packageItems = [{
  item: 'Ebook Principal "RE-NAISSANCE" (60 pages)',
  value: '97$'
}, {
  item: 'Bonus #1 : Guide du Style Post-Divorce',
  value: '47$'
}, {
  item: "Bonus #2 : L'Agenda de la Liberté",
  value: '27$'
}, {
  item: 'Bonus #3 : 50 Activités de Renaissance à 0$',
  value: '37$'
}, {
  item: "Bonus #4 : Le Manifeste de l'Estime de Soi",
  value: '27$'
}];
export function ClosingSection() {
  return <section className="bg-gradient-to-b from-cream to-burgundy py-10 px-6 md:py-16" data-id="element-13">
      <div className="max-w-4xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-15">
          <h2 className="font-playfair text-3xl md:text-4xl text-charcoal text-center mb-8" data-id="element-16">
            Ce soir, tu as deux chemins devant toi.
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-17">
            <div className="bg-gray-100 bg-opacity-50 p-6 rounded-lg" data-id="element-18">
              <h3 className="font-playfair text-2xl text-gray-600 mb-4" data-id="element-19">
                Chemin 1 :
              </h3>
              <div className="space-y-3 text-gray-700" data-id="element-20">
                <p data-id="element-21">
                  Tu fermes cette page. Tu retournes sur Instagram regarder des
                  gens qui semblent heureux. Tu te dis que "ça ira mieux avec le
                  temps".
                </p>
                <p data-id="element-22">
                  Et dans 6 mois, tu te retrouveras exactement au même endroit.
                  Même fatigue. Même vide. Même question dans le miroir.
                </p>
                <p className="italic" data-id="element-23">
                  "Mais où est-elle passée, la femme que j'étais ?"
                </p>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg border-2 border-gold shadow-lg" data-id="element-24">
              <h3 className="font-playfair text-2xl text-burgundy mb-4" data-id="element-25">
                Chemin 2 :
              </h3>
              <div className="space-y-3 text-charcoal" data-id="element-26">
                <p data-id="element-27">
                  Tu cliques sur le bouton ci-dessous. Dans 47 secondes, tu as
                  accès à l'intégralité du Pack RE-NAISSANCE sur ton téléphone.
                </p>
                <p data-id="element-28">
                  Ce soir, tu lis la première lettre. Demain matin, tu fais ton
                  premier exercice de 5 minutes.
                </p>
                <p data-id="element-29">Et dans 30 jours ?</p>
                <p className="font-semibold text-burgundy" data-id="element-30">
                  Tu es la femme que tu regardes dans le miroir avec fierté.
                </p>
                <p data-id="element-31">Pas parce que tout est parfait.</p>
                <p className="text-lg font-semibold" data-id="element-32">
                  Mais parce que tu as choisi de ne plus attendre la permission
                  d'exister.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-xl mb-8" data-id="element-33">
            <h3 className="font-playfair text-2xl text-burgundy text-center mb-6" data-id="element-34">
              RAPPEL DE CE QUE TU REÇOIS :
            </h3>

            <div className="space-y-3 mb-6" data-id="element-35">
              {packageItems.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-36">
                  <CheckIcon className="text-green-600 flex-shrink-0 mt-1" size={20} data-id="element-37" />
                  <div className="flex-1 flex justify-between items-center" data-id="element-38">
                    <span data-id="element-39">{item.item}</span>
                    <span className="text-burgundy font-semibold ml-4" data-id="element-40">
                      {item.value}
                    </span>
                  </div>
                </div>)}
            </div>

            <div className="border-t-2 border-gray-200 pt-4 text-center" data-id="element-41">
              <p className="text-xl mb-2" data-id="element-42">
                VALEUR TOTALE :{' '}
                <span className="line-through text-gray-500" data-id="element-43">235$</span>
              </p>
              <p className="text-4xl font-playfair font-bold text-burgundy" data-id="element-44">
                TON PRIX : 27$
              </p>
            </div>
          </div>

          <div id="pricing" className="text-center mb-8" data-id="element-45">
            <p className="text-xl text-white mb-6" data-id="element-46">
              ✨ UN SEUL CLIC SÉPARE LA FEMME QUE TU ES DE LA FEMME QUE TU
              DEVIENS.
            </p>

            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="bg-white text-burgundy px-8 py-5 rounded-lg text-xl font-bold hover:bg-opacity-90 transition-all shadow-2xl mb-4 w-full md:w-auto" onClick={() => {
            trackAddToCart({
              content_name: 'RE-NAISSANCE Pack',
              content_type: 'product',
              value: 27,
              currency: 'CAD'
            });
            window.open('https://redevenirmoi.com/cart/53433582256496:1', '_blank');
          }} data-id="element-47">
              Oui, Je Choisis Ma Renaissance →
            </motion.button>

            <p className="text-3xl font-bold text-white mb-6" data-id="element-48">Accès Immédiat</p>

            <div className="flex flex-wrap justify-center gap-6 text-white mb-8" data-id="element-49">
              <div className="flex items-center gap-2" data-id="element-50">
                <LockIcon size={20} data-id="element-51" />
                <span data-id="element-52">Paiement 100% Sécurisé</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-53">
                <SmartphoneIcon size={20} data-id="element-54" />
                <span data-id="element-55">Compatible Mobile, Tablette & Ordinateur</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-56">
                <ZapIcon size={20} data-id="element-57" />
                <span data-id="element-58">Tu reçois tout par email en moins de 2 minutes</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}